import { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import type { ErrorComponentProps } from "@tanstack/react-router";
import ButtonComponent from "./ButtonComponent";
import { ErrorState } from "./ErrorState";

/**
 * Router-level error component (`defaultErrorComponent`). TanStack Router
 * catches errors thrown in route components and loaders and renders this in
 * place of the failed route, with a `reset` to retry the boundary.
 */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const [eventId, setEventId] = useState<string>();

  useEffect(() => {
    setEventId(Sentry.captureException(error));
  }, [error]);

  return (
    <ErrorState eventId={eventId}>
      <ButtonComponent onClick={reset}>Try again</ButtonComponent>
      <ButtonComponent variant="outline" onClick={() => window.location.assign("/")}>
        Go to dashboard
      </ButtonComponent>
    </ErrorState>
  );
}
